module.exports = __webpack_public_path__ + "img/car-wash.b24bbb07.svg";